import { Pane } from "evergreen-ui";

export function Loading() {
  return <Pane>loading</Pane>;
}
